var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3 29c-11.6 0-21.1 9.5-21.1 21.1s9.5 21.1 21.1 21.1c11.6 0 21-9.5 21-21.1S61.8 29 50.3 29zm0 37.2c-8.9 0-16.1-7.2-16.1-16.1 0-8.9 7.2-16.1 16.1-16.1 8.8 0 16 7.2 16 16.1 0 8.9-7.2 16.1-16 16.1zM73.8 17.1c-2.2 0-4.2.8-5.7 2.3-1.5 1.5-2.3 3.5-2.3 5.7s.8 4.2 2.3 5.7c1.5 1.5 3.5 2.3 5.7 2.3s4.2-.8 5.7-2.3c1.4-1.4 2.3-3.4 2.4-5.6v-.1c0-2.1-.9-4.1-2.3-5.5-1.5-1.6-3.6-2.5-5.8-2.5zm2.1 10.1c-1.1 1.1-3.2 1.1-4.3 0-.6-.6-.9-1.3-.9-2.1s.3-1.6.9-2.1c.6-.6 1.3-.9 2.1-.9s1.6.3 2.2.9c.5.5.9 1.3.9 2 0 .9-.3 1.7-.9 2.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8 7H32.7C18.6 7 7.2 18.4 7.2 32.5v35.2c0 14.1 11.4 25.5 25.5 25.5h35.2c14.1 0 25.5-11.4 25.5-25.5V32.5C93.3 18.4 81.9 7 67.8 7zm20.5 60.7c0 11.3-9.2 20.5-20.5 20.5H32.7c-11.3 0-20.5-9.2-20.5-20.5V32.5c0-11.3 9.2-20.5 20.5-20.5h35.2c11.3 0 20.5 9.2 20.5 20.5v35.2z"
  })));
}

export default SvgInstagram;